import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';

import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { InputMetersComponent } from './pages/input-meters/input-meters.component';
import { OutputMetersComponent } from './pages/output-meters/output-meters.component';
import { PersonalInfoFormComponent } from './pages/personal-info-form/personal-info-form.component';
import { CheckEligibilityComponent } from './pages/check-eligibility/check-eligibility.component';
import { TermsComponent } from './pages/terms/terms.component';

export const routes: Routes = [
    { 
        path: '', 
        component: LandingPageComponent 
    },
    { 
        path: 'input-meters', 
        component: InputMetersComponent, 
        canActivate: [authGuard]
    },

    { 
        path: 'terms', 
        component: TermsComponent, 
        canActivate: [authGuard]
    },

    { 
        path: 'personal-info', 
        component: PersonalInfoFormComponent, 
        canActivate: [authGuard]
    },
    { 
        path: 'check-eligibility', 
        component:CheckEligibilityComponent, 
        canActivate: [authGuard]
    },

    { 
        path: 'output-meters', 
        component: OutputMetersComponent,
        canActivate: [authGuard]
    },
    // Redirect any unknown paths to the landing page
    { path: '**', redirectTo: '' }
];